import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './ProductReviewFilter.scss';

function sortFilterPredicate (filterA, filterB) {

	const valueA = filterA.value;
	const valueB = filterB.value;
	if (valueA === valueB) {

		return 0;

	}
	return valueA > valueB ? -1 : 1;

}

const ProductReviewFilter = ({ filters, handleRemoveFilter, customClass = '' }) => {

	const sortedFilters = useMemo(() => [ ...filters ].sort(sortFilterPredicate), [ filters ]);

	return (
		<div className={classNames('ProductReviewFilter', { [`${customClass}`]: Boolean(customClass) })}>
			<div className="ProductReviewFilter__count">
				{`Filters (${filters.length})`}
			</div>
			<div className="ProductReviewFilter__pills">
				{sortedFilters.map((filter) => (
					<div className="ProductReviewFilter__pill" key={filter.value}>
						<span>
							{filter.label}
						</span>
						<button
							type="button"
							aria-label={`Remove ${filter.label} filter`}
							onClick={() => handleRemoveFilter(filter)}
						>
							&times;
						</button>
					</div>
				))}
			</div>
		</div>
	);

};

ProductReviewFilter.propTypes = {
	filters: PropTypes.arrayOf(
		PropTypes.shape({
			value: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
			label: PropTypes.string
		})
	).isRequired,
	handleRemoveFilter: PropTypes.func.isRequired,
	customClass: PropTypes.string
};

export default ProductReviewFilter;
